// Approximate foreign-currency hint next to ₹ amounts for Singapore / Malaysia / Thailand players
const META = { SGD: { sym: "S$", label: "Singapore Dollar", flag: "🇸🇬" }, MYR: { sym: "RM", label: "Malaysian Ringgit", flag: "🇲🇾" }, THB: { sym: "฿", label: "Thai Baht", flag: "🇹🇭" } };
let rates = { SGD: 0.0155, MYR: 0.051, THB: 0.39 };
export const FX_OPTIONS = [["", "None (₹ only)"], ...Object.entries(META).map(([k, m]) => [k, `${m.flag} ${k} · ${m.label}`])];
export function setFxRates(r) { if (r) rates = { ...rates, ...r }; }
export function getFxCurrency() { return localStorage.getItem("rl_fx") || ""; }
export function setFxCurrency(c) { if (c) localStorage.setItem("rl_fx", c); else localStorage.removeItem("rl_fx"); }
export function defaultFxForLang(lang) { return { ms: "MYR", th: "THB", zh: "SGD" }[lang] || ""; }
/** "≈ S$1.55" or "" when no hint currency is chosen */
export function fxHint(inr) {
  const c = getFxCurrency();
  if (!c || !rates[c] || inr == null || isNaN(Number(inr))) return "";
  const v = Number(inr) * rates[c];
  return `≈ ${META[c].sym}${v.toLocaleString("en-US", { maximumFractionDigits: v < 10 ? 2 : 0 })}`;
}
